import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { UserPlus, ArrowRight, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Join() {
  const navigate = useNavigate();
  const { user, refreshTeam } = useAuth();
  const [params] = useSearchParams();
  const [code, setCode] = useState((params.get("code") || "").toUpperCase());
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    // If guest, push them to login page to authenticate with Google first
    if (!user) {
      toast.info("Accedi con Google per unirti al negozio");
      navigate("/entra", { replace: true });
    }
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setBusy(true);
    try {
      const res = await api.teamJoin(code.trim().toUpperCase());
      if (res.status === "joined") {
        toast.success(`Benvenuto in ${res.store_name}!`);
      } else {
        toast.info(`Sei già membro di ${res.store_name}, ti porto dentro`);
      }
      await refreshTeam();
      // Hard reload to pick up new cookie + new tenant data
      window.location.href = "/app/dashboard";
    } catch (err) {
      toast.error("Codice non valido", { description: err?.response?.data?.detail });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="join-page" className="max-w-md mx-auto">
      <div className="mag-card p-8 space-y-6">
        <div className="flex items-center gap-3">
          <div className="h-12 w-12 rounded-xl bg-[#E8F3EC] text-[#2B5A3F] flex items-center justify-center">
            <UserPlus size={22} />
          </div>
          <div>
            <h1 className="text-xl font-semibold" style={{ fontFamily: "Work Sans, sans-serif" }}>
              Unisciti a un negozio
            </h1>
            <p className="text-sm text-[#8E918C]">Inserisci il codice che ti ha dato l&apos;owner.</p>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="join-code" className="text-xs font-medium text-[#5C5F5A] uppercase tracking-wider">
              Codice invito
            </Label>
            <Input
              id="join-code"
              data-testid="join-code-input"
              value={code}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
              placeholder="ABC123"
              maxLength={8}
              className="mt-1.5 font-mono text-xl tracking-[0.3em] bg-white border-[#EAE7E1] text-center"
              autoFocus
            />
          </div>
          <Button
            type="submit"
            data-testid="join-submit-btn"
            disabled={busy || code.trim().length < 4}
            className="w-full bg-[#2E4A3B] hover:bg-[#21382C] text-white"
          >
            {busy ? <Loader2 size={14} className="animate-spin mr-2" /> : null}
            Entra nel negozio
            <ArrowRight size={14} className="ml-1.5" />
          </Button>
        </form>

        <div className="text-center text-xs text-[#8E918C]">
          Hai sbagliato negozio?{" "}
          <button
            type="button"
            onClick={() => navigate("/app/dashboard")}
            className="text-[#2E4A3B] underline"
          >
            Torna alla dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
